import {Injector} from '@angular/core';
import {EnumExt, EnumType} from '@shared-types';

import {TriggerActionEntity} from './trigger-action.entity';

enum ETriggerActionType {
	Notify = 'notify',
	Agent = 'agent',
	Email = 'email',
	Cancel = 'cancel',
	Alert = 'alert',
	Gtm = 'gtm',
}
export const TriggerActionType = EnumExt(ETriggerActionType);

/*** Trigger action type*/
export type TriggerActionType = EnumType<typeof TriggerActionType>;

export type TriggerActionEntityClassMetadata = {
	name: string;
	label: string;
	summary: ((trigger: TriggerActionEntity, injector: Injector) => string) | string;
	valueClass: {
		selector: 'dc-trigger-action-input-value' | 'dc-trigger-action-gtm-data' | 'dc-user-search';
		params: Record<string, any>;
	};
};
